/**
 * =============================================================================
 * DEV ONLY — bypass da verificação de associação WooCommerce (OpenID + customer)
 * =============================================================================
 *
 * Propósito temporário: permitir navegar no catálogo sem resolver customer na loja.
 * Usado enquanto CORS/APIM do adapter WooCommerce é ajustado no ambiente dev.
 *
 * Visibilidade: VITE_ENV !== "production" (localhost com yarn dev, dev.fluxmed.com.br, staging).
 * NÃO usa import.meta.env.DEV — esse flag é false em build deployado, mesmo apontando para dev.
 *
 * REMOÇÃO (para outra IA ou dev):
 * 1. Apagar este arquivo inteiro.
 * 2. Em CannabinoidStoreMarketplace.tsx, remover imports de devStoreAssociationBypass
 *    e todo bloco marcado com "DEV_STORE_ASSOCIATION_BYPASS".
 * 3. Restaurar condições originais: produtos só com customerStatus === "found",
 *    resolveCustomer sempre ao trocar loja, showLoginPrompt sem bypass.
 *
 * Não exportar em index.ts — uso local apenas.
 * =============================================================================
 */

const STORAGE_KEY = "fluxmed_dev_skip_woo_store_association";

/** Ambientes não-prod (dev local, dev.fluxmed.com.br, staging) — nunca em production. */
function isNonProductionEnvironment(): boolean {
  return import.meta.env.VITE_ENV !== "production";
}

export function isDevStoreAssociationBypassEnabled(): boolean {
  if (!isNonProductionEnvironment()) return false;
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setDevStoreAssociationBypassEnabled(enabled: boolean): void {
  if (!isNonProductionEnvironment()) return;
  try {
    if (enabled) {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // sessionStorage indisponível — ignora
  }
}

/** Exibe o botão fora de production (build dev/staging deployado ou yarn dev local). */
export function isDevStoreAssociationBypassAvailable(): boolean {
  return isNonProductionEnvironment();
}
